import { render } from "./down-resources.vue?vue&type=template&id=255345c3"
import script from "./down-resources.vue?vue&type=script&lang=js"
export * from "./down-resources.vue?vue&type=script&lang=js"

import "./down-resources.vue?vue&type=style&index=0&id=255345c3&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__